import { Button, Menu, Tooltip, useMenu } from "@kaltura/ds-react-components";
import { Calendar24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { useAddToCalendarMenuItems } from "@kaltura/mediaspace-shared-entry";
import { ButtonTextWrapper } from "../styled-components";

export interface MailMenuProps {
    entryId: string;
    categoryId?: number;
    calendarEntriesToken?: string;
}

export function MailMenu({ entryId, categoryId, calendarEntriesToken }: MailMenuProps) {
    const sendButtonAnalytics = useButtonAnalytics();

    const { close, buttonProps, menuProps } = useMenu({
        menuId: `EventListItemCalendarToggleMenu-${entryId}`,
        onOpen: () => sendButtonAnalytics("Add to calendar - Session card - Menu open", ButtonClickAnalyticsType.MENU),
    });

    const items = useAddToCalendarMenuItems({
        entryId,
        categoryId,
        calendarEntriesToken,
        analyticsValue: { location: "Session card" },
        onItemClicked: close,
    });

    return (
        <div className="kms-ds-event-list-item-menu">
            <Tooltip title={translate("Add To Calendar")} placement={"bottom"}>
                <Button
                    {...buttonProps}
                    id={`EventListItemCalendarToggleBtn-${entryId}`}
                    variant={"borderless"}
                    className={`kms-ds-event-list-item-button-calendar`}
                    size={"large"}
                    color={"secondary"}
                >
                    <Calendar24Icon />
                    <ButtonTextWrapper>{translate("Add To Calendar")}</ButtonTextWrapper>
                </Button>
            </Tooltip>
            <Menu {...menuProps} aria-labelledby={`EventListItemCalendarToggleBtn-${entryId}`}>
                {items}
            </Menu>
        </div>
    );
}

export default MailMenu;
